import { defineComponent as _defineComponent } from 'vue'
import { PaibanTaskRow, PaibanTaskStatusEnum } from '../types'


export default /*#__PURE__*/_defineComponent({
  __name: 'm-paiban-task-progress-cell',
  props: {
    text: null,
    record: null
  },
  setup(__props: any) {



function getProgressStatus(status: PaibanTaskStatusEnum): string {
  switch (status) {
    case PaibanTaskStatusEnum.FAILED:
      return 'exception'
    case PaibanTaskStatusEnum.COMPLETED:
      return 'success'
    default:
      return 'active'
  }
}

function getProgressColor(status: PaibanTaskStatusEnum): string {
  switch (status) {
    case PaibanTaskStatusEnum.FAILED:
      return '#cf1322'
    case PaibanTaskStatusEnum.COMPLETED:
      return '#159c49'
    case PaibanTaskStatusEnum.PENDING:
      return '#1890ff'
    case PaibanTaskStatusEnum.RUNNING:
      return '#18a8c7'
    case PaibanTaskStatusEnum.PAUSED:
      return '#18a8c7'
    default:
      return '#18a8c7'
  }
}

function formatPercent(val: unknown): string {
  const n = Number(val)
  if (Number.isNaN(n)) return '0%'
  return `${n}%`
}

return { __sfc: true,getProgressStatus, getProgressColor, formatPercent }
}

})